import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import {
  AbcAccordionComponent,
  AbcHtmlEditorComponent,
  AbcPopupComponent,
  _AbcButtonComponent,
} from '@barthauer/abc/ui-components';
import { Measure } from '@barthauer/custom/xmt-models';
import { DxButtonModule, DxHtmlEditorModule } from 'devextreme-angular';
import { AppService } from '../../../../services/app.service';
import { DataService } from '../../../../services/data.service';
import { SharedModule } from '../../../../shared/shared.module';
import { MeasureService } from '../../measure.service';

@Component({
  selector: 'ubt-geods-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.scss'],

  standalone: true,
  imports: [
    CommonModule,
    AbcAccordionComponent,
    AbcPopupComponent,
    DxButtonModule,
    DxHtmlEditorModule,
    SharedModule,
    _AbcButtonComponent,
    AbcHtmlEditorComponent,
  ],
})
export class DescriptionComponent implements OnChanges {
  @ViewChild('htmlEditor') htmlEditor: AbcHtmlEditorComponent;
  @Input() currentMeasure: Measure;
  @Input() canEditDescription:boolean;
  public toggleTitleVisible = false;
  public fieldValue: string;
  public propertyName: string;
  public currentDescriptionField: string;

  constructor(
    public dataService: DataService,
    private cdr: ChangeDetectorRef,
    public measureService: MeasureService,
    private elementRef: ElementRef,
    public appService: AppService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentMeasure) {
      const measure = { ...this.currentMeasure };
      measure.Concept = this.appService.sanitizeContent(measure.Concept);
      measure.DefenseMeasures = this.appService.sanitizeContent(measure.DefenseMeasures);
      measure.Dependencies = this.appService.sanitizeContent(measure.Dependencies);
      measure.ExpectedResults = this.appService.sanitizeContent(measure.ExpectedResults);
      measure.Goal = this.appService.sanitizeContent(measure.Goal);
      measure.InitialSituation = this.appService.sanitizeContent(measure.InitialSituation);
      this.currentMeasure = measure;
    }
  }

  public openPopup(fieldValue: string, propertyName: string): void {
    this.propertyName = propertyName;
    this.htmlEditor.value = fieldValue;
    this.toggleTitleVisible = true;
    this.cdr.markForCheck();
  }

  public saveChanges(propertyName: string, fieldValue: string): void {
    this.currentMeasure[propertyName] = fieldValue;
    this.measureService.updateMeasure(propertyName, fieldValue, true);
    this.toggleTitleVisible = false;
  }
  handlePaste(event: any, fieldValue: string, propertyField?: string): void {
    if (event.event) {
      if (event.event.originalEvent.type === 'paste') {
        const sanitizedContent = this.appService.sanitizeContent(fieldValue, true);
        this.currentMeasure[propertyField] = sanitizedContent;
        this.currentDescriptionField = this.currentMeasure[propertyField];
        this.htmlEditor.value = sanitizedContent;
      }
    } else {
      this.currentDescriptionField = fieldValue;
    }
  }

  public focusIn(fieldValue: string): void {
    this.currentDescriptionField = fieldValue;
  }

  public focusOut(columnName: string): void {
    this.measureService.updateMeasure(columnName, this.currentDescriptionField, true);
  }

  public updateMeasure(): void {
    //TODO: update measure data
  }
}
